import apiClient from './api.service';

export interface ShortLinkParams {
  surveyHash: string;
  ref?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
}

interface ShortLinkResponse {
  data: {
    shortUrl: string;
    code: string;
  };
}

class ShortLinkService {
  async create(params: ShortLinkParams): Promise<string> {
    const response = await apiClient.post<ShortLinkResponse>('/api/short-links', params);
    return `${window.location.origin}/s/${response.data.data.code}`;
  }
}

export const shortLinkService = new ShortLinkService();
